export const dateConstants = {
    maximumDate: 2147385599000
}